/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CloudConnectorUserModule
 */

export enum CREDENTIALS_TYPE {
    SSH = 'SSH',
    AZURE = 'AZURE',
    GCP = 'GCP',
    NSXT = 'NSXT',
    VCENTER = 'VCENTER',
}

export enum SSH_AUTHENTICATION_TYPE {
    SSH_KEY = 'SSH_KEY',
    USER_PASS = 'USER_PASS',
}

export enum AZURE_AUTHENTICATION_TYPE {
    USER_PASS = 'USER_PASS',
    SERVICE_PRINCIPAL = 'SERVICE_PRINCIPAL',
}
